import { request } from './core';

export interface DayCount {
  date: string;
  count: number;
}

export interface GalleryAnalytics {
  gallery_slug: string;
  total_views: number;
  unique_viewers: number;
  total_downloads: number;
  views_by_day: DayCount[];
  downloads_by_day: DayCount[];
}

export interface TopGallery {
  slug: string;
  title: string;
  views: number;
  downloads: number;
}

export interface AnalyticsSummary {
  gallery_views_30d: number;
  unique_gallery_viewers_30d: number;
  asset_downloads_30d: number;
  leads_30d: number;
  top_galleries: TopGallery[];
}

export const analyticsApi = {
  getAnalyticsSummary: () =>
    request<AnalyticsSummary>("GET", "/api/v1/analytics/summary"),
  getGalleryAnalytics: (slug: string) =>
    request<GalleryAnalytics>("GET", `/api/v1/galleries/${encodeURIComponent(slug)}/analytics`),
};
